module.exports = __webpack_public_path__ + "media/svg/ph-beb5ee03.svg";